"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSortableHoc = require("react-sortable-hoc");

var _common = require("../../common");

var _Handle = _interopRequireDefault(require("./Handle"));

var _Item = _interopRequireDefault(require("./Item"));

var _List = _interopRequireDefault(require("./List"));

require("./styles.css");

var _lib = require("../../lib");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Sortable =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Sortable, _PureComponent);

  function Sortable(props) {
    var _this;

    _classCallCheck(this, Sortable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sortable).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onSortEnd", function (_ref) {
      var oldIndex = _ref.oldIndex,
          newIndex = _ref.newIndex;
      return _this.updateData((0, _reactSortableHoc.arrayMove)(_this.state.data, oldIndex, newIndex));
    });

    _defineProperty(_assertThisInitialized(_this), "updateData", function (newData) {
      var data = newData;
      var onSortEnd = _this.props.onSortEnd;

      if (onSortEnd) {
        data = onSortEnd(data);
      }

      _this.setState({
        data: data
      }, function () {
        var onChange = _this.props.onChange;

        if (onChange) {
          onChange(data);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var propNames = ['disabled'];
      var names = [Sortable.className];
      (0, _lib.addClassByPropName)(names, _this.props, propNames);
      var axis = _this.props.axis;

      if (axis) {
        (0, _lib.addClassName)(names, "axis-".concat(axis));
      }

      return names.join(' ');
    });

    var _data = props.data;
    _this.state = {
      prevProps: {
        data: _data
      },
      data: (0, _lib.arrayHasItems)(_data) ? [].concat(_data) : []
    };
    return _this;
  }

  _createClass(Sortable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          data = _this$props.data,
          onChange = _this$props.onChange,
          onSortEnd = _this$props.onSortEnd,
          rest = _objectWithoutProperties(_this$props, ["className", "data", "onChange", "onSortEnd"]);

      var classNames = this.classNames();
      return _react.default.createElement(_List.default, _extends({}, rest, {
        data: this.state.data,
        helperClass: classNames,
        onSortEnd: this.onSortEnd
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var data = props.data;
      var newData = (0, _lib.arrayHasItems)(data) ? [].concat(data) : [];
      return {
        // Store the previous props in state
        prevProps: {
          data: data
        },
        data: prevProps.data !== data ? newData : state.data
      };
    }
  }]);

  return Sortable;
}(_react.PureComponent);

exports.default = Sortable;

_defineProperty(Sortable, "Handle", _Handle.default);

_defineProperty(Sortable, "Item", _Item.default);

_defineProperty(Sortable, "List", _List.default);

_defineProperty(Sortable, "className", 'MHub-Sortable-Helper');

_defineProperty(Sortable, "displayName", 'Sortable');

_defineProperty(Sortable, "propTypes", {
  className: _propTypes.default.string,
  data: _propTypes.default.arrayOf(_propTypes.default.any),
  itemNode: _common.customPropTypes.render,
  disabled: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onSortEnd: _propTypes.default.func,
  // sortable props
  axis: _propTypes.default.string
});

_defineProperty(Sortable, "defaultProps", {
  className: null,
  data: [],
  itemNode: function itemNode(item, idx) {
    return _react.default.createElement(_Item.default, {
      key: idx,
      idx: idx,
      index: idx,
      data: item
    });
  },
  disabled: false,
  onChange: null,
  onSortEnd: null,
  // sortable props
  axis: 'y'
});